import { asyncActionCreators } from '../../utils/actions';

export const fetchProfile = asyncActionCreators('FETCH_PROFILE');
export const postProfile = asyncActionCreators('POST_PROFILE');

export const fetchPassport = asyncActionCreators('FETCH_PASSPORT');
export const postPassport = asyncActionCreators('POST_PASSPORT');

export const fetchAddress = asyncActionCreators('FETCH_ADDRESS');
export const postAddress = asyncActionCreators('POST_ADDRESS');

export const fetchPassportAddress = asyncActionCreators('FETCH_PASSPORT_ADDRESS');
export const postPassportAddress = asyncActionCreators('POST_PASSPORT_ADDRESS');

export const fetchVehicles = asyncActionCreators('FETCH_VEHICLES');
export const postVehicle = asyncActionCreators('POST_VEHICLE');
export const postDeviceName = asyncActionCreators('POST_DEVICE_NAME');

export const postContract = asyncActionCreators('POST_CONTRACT');

export const fetchConfidants = asyncActionCreators('FETCH_CONFIDANTS');



// WEBPACK FOOTER //
// ./src/sagas/settings/actions.js